module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"add_media":"사진/동영상 첨부하기","add_photo":"사진 첨부하기","max_media_count":"(최대 {0}개)","media_count_exceeded":"{0}개까지 업로드할 수 있으므로, 선택한 사진/동영상 중 {1}개만 첨부합니다.","capture_excluded":"캡처 이미지는 업로드할 수 없으므로, 선택한 사진/동영상 중 캡처 이미지를 제외하고 첨부합니다.","capture_excluded_and_media_count_exceeded":"캡처 이미지는 제외하며, 선택한 사진/동영상 중 {0}개만 첨부합니다."}}')
  delete Component.options._Ctor
}
